import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { NavBarComponent } from "./nav-bar/nav-bar.component";
import { FrontPageComponent } from "./front-page/front-page.component";
import { WishListComponent } from "./wish-list/wish-list.component";
import { MatToolbarModule, MatTableModule, MatInputModule, MatSortModule } from "@angular/material";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { NoCacheInterceptor } from "./no-cache.interceptor";

@NgModule({
  declarations: [
    AppComponent,
    NavBarComponent,
    FrontPageComponent,
    WishListComponent
  ],
  imports: [BrowserModule, AppRoutingModule, MatToolbarModule, BrowserAnimationsModule, MatTableModule, MatInputModule, MatSortModule, HttpClientModule],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: NoCacheInterceptor,
    multi: true
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
